import { render, staticRenderFns } from "./ConsultarUnidadesGestoras.vue?vue&type=template&id=2a5495ed"
import script from "./ConsultarUnidadesGestoras.vue?vue&type=script&lang=ts"
export * from "./ConsultarUnidadesGestoras.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports